<template>
  <v-container
    v-show="!$apollo.loading"
    fill-height
    container--fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md9
        lg9
      >
        <h2 v-if="$route.name == 'New Project'">
          {{ $t('projects.newStrategy') }}
        </h2>
        <h2 v-else>
          {{ $t('projects.editProject') }}
        </h2>
        <v-tabs :value="getActiveTab">
          <v-tab
            v-for="(n,i) in [$t('projects.profile'), $t('projects.dataRoom'), $t('projects.details')]"
            :key="i"
            @click="ChangeTab(i)"
          >
            {{ n }}
          </v-tab>
        </v-tabs>
        <v-card>
          <v-form>
            <form-profile
              v-show="getActiveTab === 0"
              ref="tab0"
            />
            <form-dataroom
              v-show="getActiveTab === 1"
              ref="tab1"
              @onChangeExchange="onChangeExchange"
            />
            <form-details
              v-show="getActiveTab === 2"
              ref="tab2"
              :opts="opts"
            />
            <v-layout>
              <v-flex
                xs12
                md12
              >
                <v-btn
                  fab
                  outlined
                  small
                  text
                  @click="$router.push('/modules/strategies')"
                >
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-btn
                  color="primary"
                  style="float:right"
                  :disabled="loading"
                  :loading="loading"
                  @click="next"
                >
                  {{ $route.params.id === undefined ? $t('globals.nextButton') : $t('globals.saveButton') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FormProfile from "@/views/Modules/SpotFutures/Strategies/partial/FormProfile.vue";
import FormDetails from "@/views/Modules/SpotFutures/Strategies/partial/FormDetails.vue";
import FormDataroom from "@/views/Modules/SpotFutures/Strategies/partial/FormDataRoom.vue";

import { mapGetters, mapMutations } from "vuex";

import UPDATE_PROJECT_MUTATION from "@/graphql/mutations/UpdateProject.gql";
import CREATE_PROJECT_MUTATION from "@/graphql/mutations/CreateProject.gql";
import USER_PROJECT_QUERY from "@/graphql/queries/UserProject.gql";

export default {
  name: "ProjectForm",
  components: {
    FormProfile,
    FormDetails,
    FormDataroom
  },
  data: () => ({
    loading: false,
    opts: {
      baseCurrency: 'BTC',
      tradingType: 'futures',
      copyTrading: true
    }
  }),
  apollo: {
    userProject: {
      query() {
        return USER_PROJECT_QUERY;
      },
      variables() {
        return {
          id: this.$route.params.id
        };
      },
      skip() {
        return this.$route.params.id == undefined;
      },
      result({loading, data}) {
        if (!loading) {
          this.setProject(data.userProject)
          this.opts = {
            baseCurrency: data.userProject.base_currency,
            tradingType: data.userProject.strategytype,
            copyTrading: data.userProject.type == 'trading.copy' ? true : false
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters("project", ["getActiveTab", "getProject"]),
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
  },
  watch: {
    getWhiteLabel(val){
      if (this.routeNotAllowed(val, 'spot') && this.routeNotAllowed(val, 'futures') ) {
        this.$router.push('/dashboard')
      }
    }
  },
  mounted() {
    this.setTab(0);
  },
  methods: {  
    ...mapMutations("project", ["setTab", "setProject"]),
    onChangeExchange(val) {
      this.opts = {
        baseCurrency: val.baseCurrency,
        tradingType: val.tradingType,
      }
    },
    ChangeTab(i) {
      this.setTab(i);
    },
    next() {
      let tab = "tab" + this.getActiveTab;
      this.$refs[tab].save();

      if (
        this.$route.params.id == undefined &&
        !this.$refs[tab].$v.$invalid &&
        this.getActiveTab < 2
      ) {
        this.setTab(this.getActiveTab + 1);
        return;
      }

      this.$refs.tab0.save();
      this.$refs.tab1.save();
      this.$refs.tab2.save();
  
      if (!this.$refs.tab0.$v.$invalid 
          && !this.$refs.tab1.$v.$invalid 
          && !this.$refs.tab2.$v.$invalid
          && (!this.$refs.tab2.$refs.feeStructure || !this.$refs.tab2.$refs.feeStructure.$v.$invalid)
          ) {
         this.save();
      }

    },
    save() {
      this.loading = true;
      let MUTATION = UPDATE_PROJECT_MUTATION;
      if (this.$route.params.id == undefined)
        MUTATION = CREATE_PROJECT_MUTATION;
      this.$apollo
        .mutate({
          mutation: MUTATION,
          variables: this.getProject
        })
        .then(data => {
          this.$router.push("/modules/strategies");
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  }
}
</script>

<style lang="scss">
#project-name {
  text-transform: capitalize;
}
#project-ticker {
  text-transform: uppercase;
  font-weight: 700;
}
.md-radio {
  display: flex;
}
</style>
